import { createApi } from "@reduxjs/toolkit/query/react";
import { apiurl } from "@/Config/ApiConfig/ApiUrl.jsx";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const shipmentEXbondApi = createApi({
  reducerPath: "shipmentEXbondApi",
  baseQuery,
  tagTypes: ["Exbond"],
  endpoints: (builder) => ({
    getShipmentExbondById: builder.query({
      query: ({id}) => `export/shipment/exbond/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];

        // Ensure it's always an array
        const normalized = Array.isArray(data) ? data : [data];

        // Add `id` field from exportEntityId
        return normalized.map((item) => ({
          ...item,
          id: item.exportShipmentExBondId, 
        }));
      },
    }),

    updateExbond: builder.mutation({
      query: ({ id, subId, ...data }) => ({
        url: `export/shipment/exbond/${id}/${subId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { exbond: data }, 
      }),
      invalidatesTags: ["Exbond"],
    }),

    deleteExbond: builder.mutation({
      query: ({ id }) => ({
        url: `export/shipment/exbond/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Exbond"],
    }),

    createExbond: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `export/shipment/exbond/${id}`,
        method: "PUT", 
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { exbond:data },
      }),
      invalidatesTags: ["Exbond"],
    }),
  }),
});

export const {
  useCreateExbondMutation,
  useUpdateExbondMutation,
  useDeleteExbondMutation,
  useLazyGetShipmentExbondByIdQuery,
} = shipmentEXbondApi;
